'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoLoop = function IoLoop(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm21.4 23.4v4.6c3.8-0.7 6.7-3.9 6.7-8 0-1.2-0.3-2.3-0.8-3.4-0.2-0.5-0.4-1-0.7-1.4l3.7-3.3c0.1 0.1 0.1 0.2 0.2 0.3 1.7 2.2 2.6 4.8 2.6 7.8v0.3c-0.2 5.6-3.7 10.2-8.7 12-0.9 0.4-2 0.7-3 0.7v4.5l-8-7 3.4-3.1z m-14.4-3.7c0.2-5.6 3.8-10.4 8.8-12.1 1-0.3 1.9-0.6 2.9-0.6v-4.5l8 7-3.4 3.1-4.7 4 0.1-4.6c-3.8 0.7-6.7 4-6.7 8 0 1.3 0.3 2.4 0.8 3.5 0.2 0.5 0.4 0.9 0.7 1.3l-3.7 3.4c-0.1-0.2-0.1-0.2-0.2-0.4-1.6-2.2-2.6-4.9-2.6-7.8v-0.3z' })
        )
    );
};

exports.default = IoLoop;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/loop.js
// module id = 2826
// module chunks = 168707334958949